export default __webpack_public_path__ + "static/media/BluJay Solutions.a889035c.png";